import React, { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Typography } from '@material-ui/core';
import { includes } from 'lodash';

import './projectStatusView.scss';
import { PROJECT_ERROR_STATUS_STATES } from 'constants/staffing';
import { getProjectStatusStyles } from 'utils/staffing/status';
import StatusErrorDialog from 'components/Dialogs/StatusErrorDialog';

/**
 * Project status pill. When the project is in an error status and `statusError`
 * is set, the pill opens a dialog with the full error (instead of a tooltip)
 * so multi-line messages remain readable and copyable.
 */
const ProjectStatusView = props => {
  const { status, statusError } = props;
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  const hasClickableError =
    Boolean(statusError) && includes(Object.values(PROJECT_ERROR_STATUS_STATES), status);

  const statusTitle = getProjectStatusStyles(status).title;

  const handlePillClick = event => {
    // Project cards wrap content that navigates on click; stop that when opening the dialog.
    event.stopPropagation();
    event.preventDefault();
    setIsErrorDialogOpen(true);
  };

  const pill = (
    <div
      className={cx(
        'mr-1',
        'project-card-body-status',
        getProjectStatusStyles(status).containerClassname,
      )}
      onClick={hasClickableError ? handlePillClick : undefined}
      onKeyDown={
        hasClickableError
          ? event => {
              if (event.key === 'Enter' || event.key === ' ') {
                handlePillClick(event);
              }
            }
          : undefined
      }
      role={hasClickableError ? 'button' : undefined}
      tabIndex={hasClickableError ? 0 : undefined}
      style={hasClickableError ? { cursor: 'pointer' } : undefined}
      title={hasClickableError ? 'Click to view error details' : undefined}
    >
      <Typography className={cx('project-card-body-status-text white-space-no-wrap')}>
        {statusTitle}
      </Typography>
    </div>
  );

  return (
    <div className="d-flex align-items-center flex-wrap project-status-pill">
      {pill}
      {hasClickableError && (
        <StatusErrorDialog
          isOpen={isErrorDialogOpen}
          onClose={() => setIsErrorDialogOpen(false)}
          title={statusTitle}
          statusError={statusError}
        />
      )}
    </div>
  );
};

ProjectStatusView.propTypes = {
  status: PropTypes.string,
  statusError: PropTypes.string,
};

export default ProjectStatusView;
